export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  SETUP: '/setup',
  ACTIVATION: '/activation',
  LICENSES: '/licenses',
  LICENSE: '/licenses/:licenseId',
  SEAT_SESSIONS: '/seat-sessions',
  ACTIVITY: '/activity',
  SETTINGS: '/settings',
  NOT_FOUND: '*'
} as const;

export type RoutePaths = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];
